import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

async function update(axios: AxiosInstance, conversationId: number, dataForEndpoint: any): Promise<object> {
  const { data } = await axios.post(`${config.apiBaseUrl}/op/v1/conversation/${conversationId}/message`, dataForEndpoint);
  return data;
}

export default function useCreateConversationMessageMutation(conversationId: number) {
  const axios = useAxios();

  return useMutation({
    mutationFn: (dataForEndpoint: any) => update(axios, conversationId, dataForEndpoint),
  });
}
